require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./categories-شروحات-فيديو.json") })
        }
      }, "path---categories-شروحات-فيديو");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---categories-شروحات-فيديو!./.cache/json/categories-شروحات-فيديو.json
// module id = 540
// module chunks = 231608221292675